import React from "react";
import { Route, Navigate } from "react-router-dom";
import Login from "MainPages/Login/login";
import Dashboard from "MainPages/Dashboard/Dashboard";
import MasterList from "MainPages/Master/MasterList";
import CPFContribution from "MainPages/Master/CPFContribution/CPFContribution";
// import Coupons from "../feature-module/coupons/coupons";
import { all_routes } from "./all_routes";

import EmployeeList from "MainPages/Employee/EmployeeList";
import AddEmployee from "MainPages/Employee/AddEmployee";
import EditEmployee from "MainPages/Employee/EditEmployee";
import ViewEmployee from "MainPages/Employee/ViewEmployee";
import DepartmentList from "MainPages/Master/Department/DepartmentList";
import DesignationList from "MainPages/Master/Designation/DesignationList";
import LeaveManagement from "MainPages/Leave/LeaveManagement";
import ApplyLeave from "MainPages/Leave/ApplyLeave";
import EmployeeLeave from "MainPages/Leave/EmployeeLeave";
import LeaveType from "MainPages/Leave/Master/LeaveType";
import PublicHoliday from "MainPages/Leave/PublicHoliday/PublicHoliday";
import AttendanceManagement from "MainPages/Attendance/AttendanceManagement";
import AttendanceTimesheet from "MainPages/Attendance/AttendanceTimesheet";
import MonthlyAttendance from "MainPages/Attendance/MonthlyAttendance";
import DayAttendance from "MainPages/Attendance/DayAttendance";
import AllowanceList from "MainPages/Payroll/Allownace";
import DeductionList from "MainPages/Payroll/Deduction";
import Payroll from "MainPages/Payroll/Payroll";
import GeneratePayroll from "MainPages/Payroll/GeneratePayroll";
import PayslipViewer from "MainPages/Payroll/Payslip-PayslipViewer";
import AttendanceReport from "MainPages/Report/AttendanceReport";
import LeaveReport from "MainPages/Report/LeaveReport";
import MonthlyPayrollSummary from "MainPages/Report/MonthlyPayrollSummary";
import PayslipReport from "MainPages/Report/PayslipReport";
import CompanySetting from "MainPages/Setting/CompanySetting";
import UserProfile from "MainPages/User/User-Profile";
import ClaimTypeManagement from "MainPages/Claim/Type/ClaimTypeManagement";
import ClaimList from "MainPages/Claim/Manage/ClaimList";
import AddClaim from "MainPages/Claim/Manage/AddClaim";
import EditClaim from "MainPages/Claim/Manage/EditClaim";
import CPFContributionRate from "MainPages/Master/CPFContributionRate/CPFContributionRate";
import CPFPercentage from "MainPages/Master/CPFPercentage/CPFPercentage";
import CPFPercentageFLI from "MainPages/Master/CPFPercentageFLI/CPFPercentageFLI";
import CPFType from "MainPages/Master/CPFType/CPFType";
import Location from "MainPages/Master/Location/Location";
import PassType from "MainPages/Master/PassType/PassType";
import Paymode from "MainPages/Master/Paymode/Paymode";
import AddLocation from "MainPages/Master/Location/AddLocation";
import EditLocation from "MainPages/Master/Location/EditLocation";
import AddCPFContributionRate from "MainPages/Master/CPFContributionRate/AddCPFContributionRate";
import AddCPFPercentage from "MainPages/Master/CPFPercentage/AddCPFPercentage";
import AddCPFPercentageFLI from "MainPages/Master/CPFPercentageFLI/AddCPFPercentageFLI";
import AddMultipleClaims from "MainPages/Claim/Manage/AddMultipleClaims";
import EditCPFPercentage from "MainPages/Master/CPFPercentage/EditCpfPercentage";
import EditCPFPercentageFLI from "MainPages/Master/CPFPercentageFLI/EditPercentageFLI";
import EmployeeAllowance from "MainPages/EmpAllowance/EmployeeAllowance";
import AddEmpAllowance from "MainPages/EmpAllowance/AddEmpAllowance";
import EmployeeDeductions from "MainPages/EmpDeduction/EmployeeDeduction";
import EditEmpDeduction from "MainPages/EmpDeduction/EditEmpDeduction";
import AddEmpDeduction from "MainPages/EmpDeduction/AddEmpDeduction";
import EmployeeLeave2 from "MainPages/Leave/EmployeeLeave2";
import AddMultipleCPFPercentage from "MainPages/Master/CPFPercentage/AddMultipleCPFPercentage";
import AddMultipleCPFPercentageFLI from "MainPages/Master/CPFPercentageFLI/AddMultipleCPFPercentageFLI";
import Acadamics from "MainPages/Master/Acadamics/Acadamics";
import Bank from "MainPages/Master/Bank/Bank";
import Country from "MainPages/Master/Country/Country";
import Race from "MainPages/Master/Race/Race";
import Relationship from "MainPages/Master/Relationship/Relationship";
import Identification from "MainPages/Master/Identification/Identification";
import Nationality from "MainPages/Master/Nationality/Nationality";
import Foreignerlevy from "MainPages/Master/Foreignerlevy/Foreignerlevy";
import InsuranceType from "MainPages/Master/InsuranceType/InsuranceType";
import AddInsuranceType from "MainPages/Master/InsuranceType/AddInsuranceType";
import VehicleCategory from "MainPages/Master/VehileCategory/VehileCategory";
import EditInsuranceType from "MainPages/Master/InsuranceType/EditInsuranceType";
import VehicleAccident from "MainPages/Master/VehicleAccident/VehicleAccident";
import DieselUsage from "MainPages/Master/DieselUsage/DieselUsage";
import VehicleType from "MainPages/Master/VehicleType/VehicleType";

import VehicleInformation from "MainPages/Master/VehicleInformation/VehicleInformation";
import AddVehicleInformation from "MainPages/Master/VehicleInformation/AddVehicleInformation";
import EditVehicleInformation from "MainPages/Master/VehicleInformation/EditVehicleInformation";
import VehicleExpenses from "MainPages/Master/VehicleExpenses/VehicleExpenses";
import AddVehicleExpenses from "MainPages/Master/VehicleExpenses/AddVehicleExpenses";
import EditVehicleExpenses from "MainPages/Master/VehicleExpenses/EditVehicleExpenses";
import VehicleIndemnity from "MainPages/Master/VehicleIndemnity/VehicleIndemnity";
import AddVehicleIndemnity from "MainPages/Master/VehicleIndemnity/AddVehicleIndemnity";
import EditVehicleIndemnity from "MainPages/Master/VehicleIndemnity/EditVehicleIndemnity";

import ImportAttendance from "MainPages/Attendance/ImportAttendance";
import ImportEmployee from "MainPages/Employee/ImportEmployee";
import ForgotPassword from "MainPages/Login/ForgetPassword";
import PasswordSentSuccess from "MainPages/Login/PasswordSentSuccess";
import AttendanceFilter from "MainPages/Attendance/AttendanceFilter";
import ShiftType from "MainPages/Master/ShiftType/ShiftType";
import EditShiftPolicy from "MainPages/Shift/ShiftPolicy/EditShiftPolicy";
import AddShiftPolicy from "MainPages/Shift/ShiftPolicy/AddShiftPolicy";
import ShiftPolicy from "MainPages/Shift/ShiftPolicy/ShiftPolicy";
import EmployeeShiftMapping from "MainPages/Shift/Mapping/EmployeeShiftMapping";
import Group from "MainPages/Master/Group/group";
import Project from "MainPages/Project/project/Project";
import AddProject from "MainPages/Project/project/AddProject";
import EditProject from "MainPages/Project/project/EditProject";
import Task from "MainPages/Project/task/Task";
import AddTask from "MainPages/Project/task/AddTask";
import EditTask from "MainPages/Project/task/EditTask";
import ShiftRotation from "MainPages/Shift/ShiftRotation/ShiftRotation";
import UserMaster from "MainPages/User/Master/UserMaster";
import UserGroup from "MainPages/User/Group/userGroup";
import AddUserMaster from "MainPages/User/Master/AddUserMaster";
import EditUserMaster from "MainPages/User/Master/EditUserMaster";
import UserRoleManagement from "MainPages/User/Roles/UserRoleManagement";
import TimeLog from "MainPages/Attendance/TimeLog";
import LevyType from "MainPages/Master/LevyType/LevyType";
import LevyAmountType from "MainPages/Master/LevyAmountType/LevyAmountType";
import EditEmpAllowance from "MainPages/EmpAllowance/EditEmpAllowance";
import PayrollStaging from "MainPages/Payroll/Staging";
import ExpiryDocReport from "MainPages/Report/ExpiryDocReport";
import EditPayrollStaging from "MainPages/Payroll/Staging-Edit";
import ForecastReport from "MainPages/Report/ForecastReport";
import TimelogSheet from "MainPages/Attendance/timelog/TimelogSheet";
import HikeDetails from "MainPages/Employee/HikeDetails";
import AdvancePaymentList from "MainPages/Loan/AdvancePayment/AdvancePaymentList";
import AddAdvancePayment from "MainPages/Loan/AdvancePayment/AddAdvancePayment";
import EmployeeAllowanceDeduction from "MainPages/EmpAllowanceDeduction/EmployeeAllowanceDeducton";
import AddEmpAllowanceDeduction from "MainPages/EmpAllowanceDeduction/AddEmpAllowanceDeduction";
import EditEmpAllowanceDeduction from "MainPages/EmpAllowanceDeduction/EditEmpAllowanceDeduction";
import ContractType from "MainPages/Master/ContractType/ContractType";
import EmploymentType from "MainPages/Master/EmploymentType/EmploymentType";
import MOMTrade from "MainPages/Master/MomTrade/MomTrade";
import Dormitory from "MainPages/Master/Dormitory/Dormitory";
import AddDormitory from "MainPages/Master/Dormitory/AddDormitory";
import EditDormitory from "MainPages/Master/Dormitory/EditDormitory";
import ReportList from "MainPages/Report/ReportList";
import EmployeeStatus from "MainPages/Master/EmployeeStatus/EmployeeStatus";
import EmpContractReport from "MainPages/Report/EmpContractReport";
import AdditionDeductionReport from "MainPages/Report/AdditionDeductionReport";
import AdvancePaymentReport from "MainPages/Report/AdvancePaymentReport";
import AddBank from "MainPages/Master/Bank/AddBank";
import EditBank from "MainPages/Master/Bank/EditBank";
import ManHourProjectReport from "MainPages/Report/ManHourProjectReport";
import DailyWorkOrderReport from "MainPages/Report/DailyWorkOrderReport";
import VisaType from "MainPages/Master/Visa/VisaType";
import EmployeeDetails from "MainPages/Report/EmployeeDetails";
import AdvanceRePaymentReport from "MainPages/Report/AdvanceRepaymentReport";
import WorkingDayType from "MainPages/Master/WorkingDaysType/WorkingDayType";
import EmployeeWorkType from "MainPages/Master/EmployeeWorkType/EmployeeWorkType";
import EmployeeType from "MainPages/Master/EmployeeType/EmployeeType";
import ImportTimelog from "MainPages/Attendance/ImportTimelog";
import EmailConfiguration from "MainPages/Setting/EmailConfiguration";
import EmployeeMaster from "MainPages/User/Employee/EmployeeMaster";
import EmpWorkingHours from "MainPages/Employee/EmpWorkingHours";
import EmpLeaveHistory from "MainPages/Report/leave/EmpLeaveHistory";
import EmpLevyReport from "MainPages/Report/payroll/EmpLevyAmountReport";
import EmployeeCount from "MainPages/Dashboard/EmployeeCount";
import EmployeeCountReport from "MainPages/Report/employee/EmployeeCountReport";
import Unauthorized from "MainPages/ErrorPages/unAuthorized";
import ImportEmpAllowanceAndDeduction from "MainPages/EmpAllowanceDeduction/ImportEmpAllowanceAndDeduction";
import GenerateAllowanceAndDeduction from "MainPages/EmpAllowanceDeduction/GenerateAllowanceAndDeduction";
import EmailAlertList from "MainPages/Setting/EmailAlert/EmailAlretList";
import AddEmailAlert from "MainPages/Setting/EmailAlert/AddEmailAlert";
import EditEmailAlert from "MainPages/Setting/EmailAlert/EditEmailAlert";
import PayrollEdit from "MainPages/Payroll/Payroll-Edit";
import ProjectReport from "MainPages/Report/ProjectReport";
import ViewApplyLeave from "MainPages/Leave/ViewApplyLeave";
import KETInformation from "MainPages/Others/KET/KetInformation";
import AdvancePaymentDetail from "MainPages/Loan/AdvancePayment/AdvancePaymentDetail";
import LoginDetails from "MainPages/Employee/LoginDetails";

import AuditLogList from "MainPages/Setting/AuditLog/AuditLogLits";
import AuditLogDetails from "MainPages/Setting/AuditLog/AuditLogDetails";
import OfferLetter from "MainPages/Employee/OfferLetter/OfferLetter";
import UploadOfferLetter from "MainPages/Employee/OfferLetter/UploadOfferLetter";
import KetForm from "MainPages/Others/KET/KetForm";
import AddAnnouncement from "MainPages/Company/Announcement/AddAnnouncement";
import EditAnnouncement from "MainPages/Company/Announcement/EditAnnouncement";
import AnnouncementList from "MainPages/Company/Announcement/AnnouncementList";
import Trade from "MainPages/Master/Trade/Trade";
import AttendanceQRCode from "MainPages/Attendance/QR/AttendanceQRCode";
import ProjectCostingReport from "MainPages/Report/ProjectCostingReport";
import BankPaymentList from "MainPages/Payroll/BankPaymentList";
import IR8AForm from "MainPages/Government/IRAS/IR8A/IR8AForm";
import IR8AFormList from "MainPages/Government/IRAS/IR8A/IR8AFormList";
import EditIR8AForm from "MainPages/Government/IRAS/IR8A/EditIR8AForm";
import UnAppliedLeaveList from "MainPages/Leave/UnAppliedLeaveList";
import AllNotification from "MainPages/Notification/AllNotification";
import AttendanceListing from "MainPages/Attendance/AttendanceListing";
import EmployeeMovements from "MainPages/Employee/EmployeeMovements";
import ContractTemplate from "MainPages/Others/Contract/Template/ContractTemplate";
import CreateContractTemplate from "MainPages/Others/Contract/Template/CreateContractTemplate";
import UpdateContractTemplate from "MainPages/Others/Contract/Template/UpdateContractTemplate";
import EmployeeContract from "MainPages/Employee/EmployeeContract";
import ViewUserMaster from "MainPages/User/Master/ViewUserMaster";
import ViewPayrollStaging from "MainPages/Payroll/Staging-View";

const routes = all_routes;

export const publicRoutes = [
  {
    id: 1,
    path: routes.home,
    name: "home",
    element: <Dashboard />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
    action: "haveView",
  },
  {
    id: 2,
    path: routes.dashboard,
    name: "dashboard",
    element: <Dashboard />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
    action: "haveView",
  },
  {
    id: 3,
    path: `${routes.employee}/*`,
    name: "employeeList",
    element: <EmployeeList />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: "3.1",
    path: `${routes.employee}${routes.employee_list}`,
    name: "employeeList",
    element: <EmployeeList />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: "3.1.1",
    path: `${routes.employee}${routes.employee_login_details}`,
    name: "employee_login_details",
    element: <LoginDetails />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: "3.1.2",
    path: `${routes.employee}${routes.employee_offer_letter}`,
    name: "employee_offer_letter",
    element: <OfferLetter />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: "3.1.3",
    path: `${routes.employee}${routes.upload_employee_offer_letter}/:employeeCode`,
    name: "upload_employee_offer_letter",
    element: <UploadOfferLetter />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: "3.1.4",
    path: `${routes.emp_contract_list}`,
    name: "emp_contract_list",
    element: <EmployeeContract />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: "3.2",
    path: `${routes.employee}${routes.employee_add}`,
    name: "addEmployee",
    element: <AddEmployee />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveAdd",
  },
  {
    id: "3.3",
    path: `${routes.employee}${routes.employee_edit}/:code`,
    name: "editEmployee",
    element: <EditEmployee />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveEdit",
  },
  {
    id: "3.4",
    path: `${routes.employee}${routes.employee_import}`,
    name: "employee_import",
    element: <ImportEmployee />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveAdd",
  },
  {
    id: "3.5",
    path: `${routes.employee}${routes.employee_view}/:code`,
    name: "viewEmployee",
    element: <ViewEmployee />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: "3.6",
    path: `${routes.employee_movements}`,
    name: "employee_movements",
    element: <EmployeeMovements />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Employee Directory",
    action: "haveView",
  },
  {
    id: 4.1,
    path: `${routes.leave}${routes.leave_manangement}`,
    name: "Leave Management",
    element: <LeaveManagement />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Leave Management",
    action: "haveView",
  },

  {
    id: 4.2,
    path: `${routes.leave}${routes.apply_leave}`,
    name: "Apply Leave",
    element: <ApplyLeave />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Leave Management",
    action: "haveView",
  },
  {
    id: 4.2,
    path: `${routes.leave}${routes.un_applied_leave}`,
    name: "un_applied_leave",
    element: <UnAppliedLeaveList />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Leave Management",
    action: "haveView",
  },
  {
    id: 4.2,
    path: `${routes.leave}${routes.view_apply_leave}`,
    name: "View Apply Leave",
    element: <ViewApplyLeave />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Leave Management",
    action: "haveEdit",
  },

  {
    id: 4.3,
    path: `${routes.leave}${routes.employee_leave}`,
    name: "Employee Leave Management",
    element: <EmployeeLeave2 />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Employee Leave Records",
    action: "haveView",
  },

  {
    id: "4..4",
    path: `${routes.leave}${routes.employee_leave2}`,
    name: "Employee Leave Management 2",
    element: <EmployeeLeave />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Leave Management",
    action: "haveView",
  },

  {
    id: 4.5,
    path: `${routes.leave}${routes.leave_type}`,
    name: "Leave Type",
    element: <LeaveType />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Leave Categories",
    action: "haveView",
  },

  {
    id: 4.6,
    path: `${routes.leave}${routes.public_holiday}`,
    name: "Public Holiday",
    element: <PublicHoliday />,
    route: Route,
    moduleCode: "Compensation Adjustments",
    accessCode: "Holiday Calendar",
    action: "haveView",
  },
  {
    id: 5.1,
    path: `${routes.attendance}${routes.attendance_management}`,
    name: "Attendance Management",
    element: <AttendanceManagement />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  {
    id: "5.2",
    path: `${routes.attendance}${routes.time_log}`,
    name: "TimeLog",
    element: <TimeLog />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  {
    id: "5.3",
    path: `${routes.attendance}${routes.import_time_log}`,
    name: "import_time_log",
    element: <ImportTimelog />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  // {
  //   id: "5.4",
  //   path: `${routes.attendance}${routes.download_timelog}`,
  //   name: "download_timelog",
  //   element: <TimelogSheet />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // action: "haveView",
  // },

  {
    id: 5.5,
    path: `${routes.attendance}${routes.attendance_filter}`,
    name: "Attendance Filter",
    element: <AttendanceFilter />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  {
    id: 5.6,
    path: `${routes.attendance}${routes.attendance_day}`,
    name: "Day Management",
    element: <DayAttendance />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  {
    id: 5.7,
    path: `${routes.attendance}${routes.attendance_month}`,
    name: "Monthly Management",
    element: <MonthlyAttendance />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  {
    id: 5.8,
    path: `${routes.attendance}${routes.attendance_import}`,
    name: "attendance_import",
    element: <ImportAttendance />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  {
    id: 5.9,
    path: `${routes.attendance}${routes.attendance_timesheet}`,
    name: "Attendance Timesheet",
    element: <AttendanceTimesheet />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Timesheet Management",
    action: "haveView",
  },
  {
    id: 5.9,
    path: `${routes.attendance}${routes.attendance_qr}`,
    name: "attendance_qr",
    element: <AttendanceQRCode />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },
  {
    id: 5.1,
    path: `${routes.attendance_listing}`,
    name: "attendance_listing",
    element: <AttendanceListing />,
    route: Route,
    moduleCode: "Time & Attendance",
    accessCode: "Time Tracking",
    action: "haveView",
  },

  {
    id: 6,
    path: `${routes.project}`,
    name: "project_list",
    element: <Project />,
    route: Route,
    moduleCode: "Project Management",
    accessCode: "Project Portfolio",
    action: "haveView",
  },
  {
    id: "6.1",
    path: `${routes.project}${routes.project_list}/*`,
    name: "project_list",
    element: <Project />, // <Navigate to={`${routes.project}`} replace />,
    route: Route,
    moduleCode: "Project Management",
    accessCode: "Project Portfolio",
    action: "haveView",
  },
  {
    id: "6.2",
    path: `${routes.project}${routes.project_list}${routes.add_project}`,
    name: "add_project",
    element: <AddProject />,
    route: Route,
    moduleCode: "Project Management",
    accessCode: "Project Portfolio",
    action: "haveAdd",
  },
  {
    id: "6.3",
    path: `${routes.project}${routes.project_list}${routes.edit_project}/:code/*`,
    name: "edit_project",
    element: <EditProject />,
    route: Route,
    moduleCode: "Project Management",
    accessCode: "Project Portfolio",
    action: "haveEdit",
  },
  {
    id: "6.4",
    path: `${routes.project}${routes.task_list}`,
    name: "task_list",
    element: <Task />,
    route: Route,
    moduleCode: "Project Management",
    accessCode: "Task Assignments",
    action: "haveView",
  },
  {
    id: "6.5",
    path: `${routes.project}${routes.task_list}${routes.add_task}`,
    name: "add_task",
    element: <AddTask />,
    route: Route,
    moduleCode: "Project Management",
    accessCode: "Task Assignments",
    action: "haveAdd",
  },
  {
    id: "6.6",
    path: `${routes.project}${routes.task_list}${routes.edit_task}/:code/*`,
    name: "edit_task",
    element: <EditTask />,
    route: Route,
    moduleCode: "Project Management",
    accessCode: "Task Assignments",
    action: "haveEdit",
  },
  {
    id: 7.1,
    path: `${routes.master}${routes.shift_type}`,
    name: "shift_type",
    element: <ShiftType />,
    route: Route,
    moduleCode: "Shift Management",
    accessCode: "Shift Policies",
    action: "haveView",
  },
  {
    id: 7.2,
    path: `${routes.shift}${routes.shift_policy}`,
    name: "shift_policy",
    element: <ShiftPolicy />,
    route: Route,
    moduleCode: "Shift Management",
    accessCode: "Shift Policies",
    action: "haveView",
  },
  {
    id: 7.3,
    path: `${routes.shift}${routes.shift_policy}${routes.add_shift_policy}`,
    name: "add_shift_policy",
    element: <AddShiftPolicy />,
    route: Route,
    moduleCode: "Shift Management",
    accessCode: "Shift Policies",
    action: "haveAdd",
  },
  {
    id: 7.4,
    path: `${routes.shift}${routes.shift_policy}${routes.edit_shift_policy}/:code`,
    name: "edit_shift_policy",
    element: <EditShiftPolicy />,
    route: Route,
    moduleCode: "Shift Management",
    accessCode: "Shift Policies",
    action: "haveEdit",
  },
  {
    id: 7.5,
    path: `${routes.shift}${routes.employee_shift_mapping}`,
    name: "employee_shift_mapping",
    element: <EmployeeShiftMapping />,
    route: Route,
    moduleCode: "Shift Management",
    accessCode: "Employee Shift Mapping",
    action: "haveView",
  },
  {
    id: 7.6,
    path: `${routes.shift}${routes.shift_rotation}`,
    name: "shift_rotation",
    element: <ShiftRotation />,
    route: Route,
    moduleCode: "Shift Management",
    accessCode: "Employee Shift Mapping",
    action: "haveView",
  },

  {
    id: 8.1,
    path: `${routes.claim}/*`,
    name: "Claim",
    element: <></>,
    route: Route,
    moduleCode: "Claims Processing",
    accessCode: "Claim Categories",
    action: "haveView",
  },

  {
    id: 8.2,
    path: `${routes.claim}${routes.claim_type}`,
    name: "Claim Type",
    element: <ClaimTypeManagement />,
    route: Route,
    moduleCode: "Claims Processing",
    accessCode: "Claim Categories",
    action: "haveView",
  },

  {
    id: 8.3,
    path: `${routes.claim}${routes.claim_list}`,
    name: "Claim list",
    element: <ClaimList />,
    route: Route,
    moduleCode: "Claims Processing",
    accessCode: "Manage Claims",
    action: "haveView",
  },

  {
    id: 8.4,
    path: `${routes.claim}${routes.claim_add}`,
    name: "Claim Add",
    element: <AddClaim />,
    route: Route,
    moduleCode: "Claims Processing",
    accessCode: "Manage Claims",
    action: "haveAdd",
  },
  {
    id: "8.5",
    path: `${routes.claim}${routes.claim_add_multiple}`,
    name: "Claim Multiple",
    element: <AddMultipleClaims />,
    route: Route,
    moduleCode: "Claims Processing",
    accessCode: "Manage Claims",
    action: "haveAdd",
  },

  {
    id: 8.6,
    path: `${routes.claim}${routes.claim_edit}/:code`,
    name: "Claim Edit",
    element: <EditClaim />,
    route: Route,
    moduleCode: "Claims Processing",
    accessCode: "Manage Claims",
    action: "haveEdit",
  },

  {
    id: 9.1,
    path: `${routes.payroll}${routes.addition}`,
    name: "Payroll Addition",
    element: <AllowanceList />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Allowance Management",
    action: "haveView",
  },
  {
    id: 9.2,
    path: `${routes.payroll}${routes.deduction}`,
    name: "payroll Deduction",
    element: <DeductionList />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Deduction Management",
    action: "haveView",
  },
  {
    id: 9.3,
    path: `${routes.payroll}${routes.payroll_lits}`,
    name: "Payroll List",
    element: <Payroll />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Records",
    action: "haveView",
  },
  {
    id: "9.3.1",
    path: `${routes.payroll_edit}/:refNo/:employeeCode`,
    name: "payroll_edit",
    element: <PayrollEdit />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Records",
    action: "haveEdit",
  },
  {
    id: 9.4,
    path: `${routes.payroll}${routes.generate_payroll}`,
    name: "Generate Payroll",
    element: <GeneratePayroll />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Generation",
    action: "haveAdd",
  },
  {
    id: 9.5,
    path: `${routes.payroll}${routes.payroll_stage}`,
    name: "payroll_stage",
    element: <PayrollStaging />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Processing Stages",
    action: "haveView",
  },
  {
    id: 9.6,
    path: `${routes.payroll}${routes.payroll_stage_edit}/:code`,
    name: "payroll_stage_edit",
    element: <EditPayrollStaging />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Processing Stages",
    action: "haveEdit",
  },
  {
    id: 9.6,
    path: `${routes.payroll}${routes.payroll_stage_view}/:code`,
    name: "payroll_stage_view",
    element: <ViewPayrollStaging />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Processing Stages",
    action: "haveView",
  },
  {
    id: 9.7,
    path: `${routes.payroll}${routes.payslip}`,
    name: "Download Payslip",
    element: <PayslipViewer />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Generation",
    action: "haveView",
  },
  {
    id: 9.6,
    path: `${routes.payroll}${routes.payroll_bank_payment_list}`,
    name: "payroll_bank_payment_list",
    element: <BankPaymentList />,
    route: Route,
    moduleCode: "Payroll Management",
    accessCode: "Payroll Processing Stages",
    action: "haveView",
  },

  {
    id: 10.1,
    path: `${routes.advance_payment}${routes.advance_payment_details}/:code`,
    name: "advance_payment_details",
    element: <AdvancePaymentDetail />,
    route: Route,
    moduleCode: "Loans & Advances",
    accessCode: "Advance Disbursement",
    action: "haveView",
  },
  {
    id: "10.1.1",
    path: `${routes.advance_payment}${routes.advance_payment_list}`,
    name: "advance_payment_list",
    element: <AdvancePaymentList />,
    route: Route,
    moduleCode: "Loans & Advances",
    accessCode: "Advance Disbursement",
    action: "haveView",
  },

  {
    id: 10.2,
    path: `${routes.advance_payment}${routes.advance_payment_add}`,
    name: "advance_payment_add",
    element: <AddAdvancePayment />,
    route: Route,
    moduleCode: "Loans & Advances",
    accessCode: "Advance Disbursement",
    action: "haveView",
  },
  {
    id: "11.1.1",
    path: `${routes.vechile_master}${routes.vehicleinformation}`,
    name: "vehicleinformation",
    element: <VehicleInformation />,
    route: Route,
    moduleCode: "Vehicle Management",
    accessCode: "Vehicle Registry",
    action: "haveView",
  },
  {
    id: "11.1.2",
    path: `${routes.vechile_master}${routes.addvehicleinformation}`,
    name: "addvehicleinformation",
    element: <AddVehicleInformation />,
    route: Route,
    moduleCode: "Vehicle Management",
    accessCode: "Vehicle Registry",
    action: "haveAdd",
  },
  {
    id: "11.1.3",
    path: `${routes.vechile_master}${routes.editvehicleinformation}/:code`,
    name: "editvehicleinformation",
    element: <EditVehicleInformation />,
    route: Route,
    moduleCode: "Vehicle Management",
    accessCode: "Vehicle Registry",
    action: "haveEdit",
  },
  {
    id: "11.2.1",
    path: `${routes.setting}${routes.email_alert}`,
    name: "email_alert",
    element: <EmailAlertList />,
    route: Route,
    moduleCode: "Vehicle Management",
    accessCode: "Vehicle Registry",
    action: "haveView",
  },
  {
    id: "11.2.2",
    path: `${routes.setting}${routes.add_email_alert}`,
    name: "add_email_alert",
    element: <AddEmailAlert />,
    route: Route,
    moduleCode: "Vehicle Management",
    accessCode: "Vehicle Registry",
    action: "haveAdd",
  },
  {
    id: "11.2.3",
    path: `${routes.setting}${routes.edit_email_alert}/:code`,
    name: "edit_email_alert",
    element: <EditEmailAlert />,
    route: Route,
    moduleCode: "Vehicle Management",
    accessCode: "Vehicle Registry",
    action: "haveEdit",
  },

  {
    id: 12.1,
    path: `${routes.setting}${routes.company_setting}`,
    name: "Company Setting",
    element: <CompanySetting />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.2",
    path: `${routes.setting}${routes.email_configuration}`,
    name: "email_configuration",
    element: <EmailConfiguration />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.3",
    path: `${routes.user_master}${all_routes.user_master_list}`,
    name: "user_master",
    element: <UserMaster />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.3.1",
    path: `${routes.user_master}${all_routes.add_user_master}`,
    name: "add_user_master",
    element: <AddUserMaster />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.3.2",
    path: `${routes.user_master}${all_routes.edit_user_master}/:code`,
    name: "edit_user_master",
    element: <EditUserMaster />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.3.3",
    path: `${routes.user_master}${all_routes.view_user_master}/:code`,
    name: "view_user_master",
    element: <ViewUserMaster />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.4",
    path: `${routes.user_group}${all_routes.user_group_list}`,
    name: "user_group",
    element: <UserGroup />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.5",
    path: `${routes.employee_master}${all_routes.employee_master_list}`,
    name: "employee_master_list",
    element: <EmployeeMaster />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },

  {
    id: "12.6",
    path: `${routes.user_role}`,
    name: "user_role",
    element: <UserGroup />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.6.1",
    path: `${routes.user_role_management}/:code`,
    name: "user_role_management",
    element: <UserRoleManagement />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.7",
    path: `${routes.user}${routes.user_profile}`,
    name: "User Profile",
    element: <UserProfile />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.1.1",
    path: `${routes.audit_log}`,
    name: "AuditLogList",
    element: <AuditLogList />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "12.1.2",
    path: `${routes.audit_log}/:code`,
    name: "AuditLog",
    element: <AuditLogDetails />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },

  {
    id: 13,
    path: routes.master,
    name: "master",
    element: <MasterList />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "13.1",
    path: `${routes.master}${routes.acadamics}`,
    name: "acadamics",
    element: <Acadamics />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Acadamics",
    action: "haveView",
  },
  {
    id: "3.2",
    path: `${routes.master}${routes.bank}`,
    name: "bank",
    element: <Bank />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Bank",
    action: "haveView",
  },
  {
    id: "3.2.2",
    path: `${routes.master}${routes.add_bank}`,
    name: "AddBank",
    element: <AddBank />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Bank",
    action: "haveAdd",
  },
  {
    id: "3.2.3",
    path: `${routes.master}${routes.edit_bank}/:code`,
    name: "EditBank",
    element: <EditBank />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Bank",
    action: "haveEdit",
  },
  {
    id: "3.5.1",
    path: `${routes.master}${routes.contractType}`,
    name: "contractType",
    element: <ContractType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "ContarctType",
    action: "haveView",
  },
  {
    id: "3.2.1",
    path: `${routes.master}${routes.group}`,
    name: "group",
    element: <Group />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Group",
    action: "haveView",
  },
  {
    id: "3.3",
    path: `${routes.master}${routes.country}`,
    name: "country",
    element: <Country />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Country",
    action: "haveView",
  },
  {
    id: "3.4",
    path: `${routes.master}${routes.cpfContribution}`,
    name: "cpfContributionList",
    element: <CPFContribution />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFContribution",
    action: "haveView",
  },
  {
    id: "3.5",
    path: `${routes.master}${routes.cpfContributionRate}`,
    name: "cpfContributionRate",
    element: <CPFContributionRate />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFContributionRate",
    action: "haveView",
  },

  {
    id: "3.5.1",
    path: `${routes.master}${routes.add_cpfContributionRate}`,
    name: "add_cpfContributionRate",
    element: <AddCPFContributionRate />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFContributionRate",
    action: "haveAdd",
  },
  {
    id: "3.6",
    path: `${routes.master}${routes.cpfPercentage}`,
    name: "cpfPercentage",
    element: <CPFPercentage />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentage",
    action: "haveView",
  },
  {
    id: "3.6.1",
    path: `${routes.master}${routes.add_cpfPercentage}`,
    name: "add_cpfPercentage",
    element: <AddCPFPercentage />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentage",
    action: "haveAdd",
  },
  {
    id: "3.7.2",
    path: `${routes.master}${routes.add_multi_cpfPercentage}`,
    name: "add_multi_cpfPercentage",
    element: <AddMultipleCPFPercentage />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentage",
    action: "haveAdd",
  },
  {
    id: "3.7.3",
    path: `${routes.master}${routes.edit_cpfPercentage}/:code`,
    name: "edit_cpfPercentage",
    element: <EditCPFPercentage />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentage",
    action: "haveEdit",
  },
  {
    id: "3.8",
    path: `${routes.master}${routes.cpfPercentageFLI}`,
    name: "cpfPercentageFLI",
    element: <CPFPercentageFLI />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentageFLI",
    action: "haveView",
  },
  {
    id: "3.8.1",
    path: `${routes.master}${routes.add_cpfPercentageFLI}`,
    name: "add_cpfPercentageFLI",
    element: <AddCPFPercentageFLI />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentageFLI",
    action: "haveAdd",
  },
  {
    id: "3.8.2",
    path: `${routes.master}${routes.add_multi_cpfPercentageFLI}`,
    name: "add_multi_cpfPercentageFLI",
    element: <AddMultipleCPFPercentageFLI />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentageFLI",
    action: "haveAdd",
  },
  {
    id: "3.8.3",
    path: `${routes.master}${routes.edit_cpfPercentageFLI}/:code`,
    name: "edit_cpfPercentageFLI",
    element: <EditCPFPercentageFLI />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFPercentageFLI",
    action: "haveEdit",
  },
  // {
  //   id: "3.4.1",
  //   path: `${routes.master}${routes.add_cpfPercentageFLI}`,
  //   name: "add_cpfPercentageFLI",
  //   element: <AddCPFPercentageFLI />,
  //   route: Route,
  //   moduleCode: "Master",
  //   accessCode: "",
  //   action: "haveView",
  // },
  {
    id: "3.5",
    path: `${routes.master}${routes.cpfType}`,
    name: "cpfType",
    element: <CPFType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "CPFTypes",
    action: "haveView",
  },
  {
    id: "3.5.5",
    path: `${routes.master}${routes.dormitory}`,
    name: "dormitory",
    element: <Dormitory />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Dormitory",
    action: "haveView",
  },
  {
    id: "3.5.5.1",
    path: `${routes.master}${routes.dormitory_add}`,
    name: "dormitory_add",
    element: <AddDormitory />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Dormitory",
    action: "haveAdd",
  },
  {
    id: "3.5.5.2",
    path: `${routes.master}${routes.dormitory_edit}/:code`,
    name: "dormitory_edit",
    element: <EditDormitory />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Dormitory",
    action: "haveEdit",
  },
  {
    id: 10.1,
    path: `${routes.master}${routes.foreignerlevy}`,
    name: "Foreignerlevy",
    element: <Foreignerlevy />,
    route: Route,
    moduleCode: "Master",
    accessCode: "ForeignerLevy",
    action: "haveView",
  },
  {
    id: 10.2,
    path: `${routes.vechile_master}${routes.vehicleCategory}`,
    name: "VehicleCategory",
    element: <VehicleCategory />,
    route: Route,
    moduleCode: "Master",
    accessCode: "VehicleCategory",
    action: "haveView",
  },
  {
    id: 11,
    path: `${routes.master}${routes.insurancetype}`,
    name: "insurance",
    element: <InsuranceType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "InsuranceType",
    action: "haveView",
  },
  {
    id: 11.1,
    path: `${routes.master}${routes.addinsurancetype}`,
    name: "addInsurance",
    element: <AddInsuranceType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "InsuranceType",
    action: "haveAdd",
  },
  {
    id: 11.1,
    path: `${routes.master}${routes.editinsurancetype}/:code`,
    name: "editInsurance",
    element: <EditInsuranceType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "InsuranceType",
    action: "haveEdit",
  },
  {
    id: 12,
    path: `${routes.vechile_master}${routes.vehicleaccident}`,
    name: "vehicleaccident",
    element: <VehicleAccident />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 13,
    path: `${routes.master}${routes.dieselusage}`,
    name: "dieselusage",
    element: <DieselUsage />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 14,
    path: `${routes.vechile_master}${routes.vehicleType}`,
    name: "vehicletype",
    element: <VehicleType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },

  {
    id: 17,
    path: `${routes.vechile_master}${routes.vehicleexpenses}`,
    name: "vehicleexpenses",
    element: <VehicleExpenses />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 17.1,
    path: `${routes.master}${routes.addvehicleexpenses}`,
    name: "addvehicleexpenses",
    element: <AddVehicleExpenses />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 17.2,
    path: `${routes.master}${routes.editvehicleexpenses}`,
    name: "editvehicleexpenses",
    element: <EditVehicleExpenses />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 18,
    path: `${routes.vechile_master}${routes.vehicleindemnity}`,
    name: "vehicleindemnity",
    element: <VehicleIndemnity />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 18.1,
    path: `${routes.master}${routes.addvehicleindemnity}`,
    name: "addvehicleindemnity",
    element: <AddVehicleIndemnity />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 18.2,
    path: `${routes.master}${routes.editvehicleindemnity}`,
    name: "editvehicleindemnity",
    element: <EditVehicleIndemnity />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "3.5.2",
    path: `${routes.master}${routes.employmentType}`,
    name: "employmentType",
    element: <EmploymentType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "EmploymentType",
    action: "haveView",
  },
  {
    id: "3.5.2.1",
    path: `${routes.master}${routes.employeeType}`,
    name: "employeeType",
    element: <EmployeeType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "3.5.2.1",
    path: `${routes.master}${routes.employeeWorkType}`,
    name: "employeeWorkType",
    element: <EmployeeWorkType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "3.5.2.1",
    path: `${routes.master}${routes.workingDayType}`,
    name: "workingDayType",
    element: <WorkingDayType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "3.5.3",
    path: `${routes.master}${routes.trade}`,
    name: "Trade",
    element: <Trade />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Trade",
    action: "haveView",
  },
  {
    id: "3.5.4",
    path: `${routes.master}${routes.momTrade}`,
    name: "momTrade",
    element: <MOMTrade />,
    route: Route,
    moduleCode: "Master",
    accessCode: "MOMTrade",
    action: "haveView",
  },

  {
    id: "3.5.5.2",
    path: `${routes.master}${routes.employeeStatus}`,
    name: "employeeStatus",
    element: <EmployeeStatus />,
    route: Route,
    moduleCode: "Master",
    accessCode: "EmployeeStatus",
    action: "haveView",
  },
  {
    id: "3.6",
    path: `${routes.master}${routes.identification}`,
    name: "identification",
    element: <Identification />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Identification",
    action: "haveView",
  },
  {
    id: "3.6",
    path: `${routes.master}${routes.location}`,
    name: "location",
    element: <Location />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Location",
    action: "haveView",
  },
  {
    id: "3.6.1",
    path: `${routes.master}${routes.location}${routes.location_add}`,
    name: "location add",
    element: <AddLocation />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Location",
    action: "haveAdd",
  },
  {
    id: "3.6.2",
    path: `${routes.master}${routes.location}${routes.location_edit}/:code`,
    name: "location edit",
    element: <EditLocation />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Location",
    action: "haveEdit",
  },
  {
    id: "3.6.2",
    path: `${routes.master}${routes.location}`,
    name: "location",
    element: <Location />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "3.6",
    path: `${routes.master}${routes.nationality}`,
    name: "nationality",
    element: <Nationality />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Nationality",
    action: "haveView",
  },
  {
    id: "3.7",
    path: `${routes.master}${routes.passType}`,
    name: "passType",
    element: <PassType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "PassType",
    action: "haveView",
  },
  {
    id: "3.8",
    path: `${routes.master}${routes.paymode}`,
    name: "paymode",
    element: <Paymode />,
    route: Route,
    moduleCode: "Master",
    accessCode: "PayMode",
    action: "haveView",
  },
  {
    id: "3.9",
    path: `${routes.master}${routes.race}`,
    name: "race",
    element: <Race />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Race",
    action: "haveView",
  },
  {
    id: "3.9",
    path: `${routes.master}${routes.visa_type}`,
    name: "visa_type",
    element: <VisaType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "VisaType",
    action: "haveView",
  },
  {
    id: "3.9",
    path: `${routes.master}${routes.relationship}`,
    name: "relationship",
    element: <Relationship />,
    route: Route,
    moduleCode: "Master",
    accessCode: "Relationship",
    action: "haveView",
  },
  {
    id: "3.10",
    path: `${routes.master}${routes.levyType}`,
    name: "levyType",
    element: <LevyType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "LevyType",
    action: "haveView",
  },
  {
    id: "3.11",
    path: `${routes.master}${routes.levyAmountType}`,
    name: "levyAmountType",
    element: <LevyAmountType />,
    route: Route,
    moduleCode: "Master",
    accessCode: "LevyAmountType",
    action: "haveView",
  },

  {
    id: 7,
    path: `${routes.employee}${routes.employee_working_hours}`,
    name: "employee_working_hours",
    element: <EmpWorkingHours />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: 7.1,
    path: `${routes.employee}${routes.employee_hike}`,
    name: "employee_hike",
    element: <HikeDetails />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },

  {
    id: 8,
    path: `${routes.department_list}`,
    name: "Departments",
    element: <DepartmentList />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Departments",
    action: "haveView",
  },
  {
    id: 9,
    path: `${routes.designation_list}`,
    name: "Designations",
    element: <DesignationList />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Designations",
    action: "haveView",
  },
  {
    id: "4.1.1",
    path: `${routes.emp_allowance_deduction}`,
    name: "emp_allowance_deduction",
    element: <EmployeeAllowanceDeduction />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "4.1.1.1",
    path: `${routes.add_emp_allowance_deduction}`,
    name: "add_emp_allowance_deduction",
    element: <AddEmpAllowanceDeduction />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Allowances & Deductions",
    action: "haveAdd",
  },
  {
    id: "4.1.1.2",
    path: `${routes.edit_emp_allowance_deduction}/:code`,
    name: "edit_emp_allowance_deduction",
    element: <EditEmpAllowanceDeduction />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Allowances & Deductions",
    action: "haveEdit",
  },
  {
    id: "4.1.1.3",
    path: `${routes.import_emp_allowance_deduction}`,
    name: "import_emp_allowance_deduction",
    element: <ImportEmpAllowanceAndDeduction />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Allowances & Deductions",
    action: "haveAdd",
  },
  {
    id: "4.1.1.4",
    path: `${routes.generate_emp_allowance_deduction}`,
    name: "generate_emp_allowance_deduction",
    element: <GenerateAllowanceAndDeduction />,
    route: Route,
    moduleCode: "Human Resources",
    accessCode: "Allowances & Deductions",
    action: "haveAdd",
  },

  {
    id: "4.1.1",
    path: `${routes.emp_allowance}`,
    name: "emp_allowance",
    element: <EmployeeAllowance />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "4.1.1.1",
    path: `${routes.add_emp_allowance}`,
    name: "add_emp_allowance",
    element: <AddEmpAllowance />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "4.1.1.1",
    path: `${routes.edit_emp_allowance}/:code`,
    name: "edit_emp_allowance",
    element: <EditEmpAllowance />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },
  {
    id: "4.1.2",
    path: `${routes.emp_deductions}`,
    name: "emp_deductions",
    element: <EmployeeDeductions />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },

  {
    id: "4.1.2.1.",
    path: `${routes.add_emp_deductions}`,
    name: "add_emp_deductions",
    element: <AddEmpDeduction />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },

  {
    id: "4.1.2",
    path: `${routes.edit_emp_deductions}/:code`,
    name: "edit_emp_deductions",
    element: <EditEmpDeduction />,
    route: Route,
    moduleCode: "Master",
    accessCode: "",
    action: "haveView",
  },

  // {
  //   id: 25.1,
  //   path: `${routes.report}${routes.attendance_report}`,
  //   name: "Attendance Report",
  //   element: <AttendanceReport />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 26,
  //   path: `${routes.report}${routes.leave_report}`,
  //   name: "Leave Report",
  //   element: <LeaveReport />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 27,
  //   path: `${routes.report}${routes.payroll_report}`,
  //   name: "Payroll Report",
  //   element: <MonthlyPayrollSummary />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 28,
  //   path: `${routes.report}${routes.payslip_report}`,
  //   name: "Payslip Report",
  //   element: <PayslipReport />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: "28.1",
  //   path: `${routes.report}${routes.expiry_report}`,
  //   name: "expiry_report",
  //   element: <ExpiryDocReport />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: "28.2",
  //   path: `${routes.report}${routes.forecast_report}`,
  //   name: "forecast_report",
  //   element: <ForecastReport />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },

  {
    id: 115,
    path: "/",
    name: "Root",
    element: <Navigate to="/" />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "",
  },
  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "",
  },
  {
    id: 116,
    path: routes.unAuthorized,
    name: "unAuthorized",
    element: <Unauthorized />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "",
  },
  {
    id: "28.2",
    path: `${routes.ket_information}`,
    name: "ket_information",
    element: <KETInformation />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.3",
    path: `${routes.fill_ket_information}/:employeeCode`,
    name: "fill_ket_information",
    element: <KetForm />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "29.1",
    path: `${routes.announcement_list}`,
    name: "fill_ket_information",
    element: <AnnouncementList />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "29.2",
    path: `${routes.add_announcement}`,
    name: "add_announcement",
    element: <AddAnnouncement />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "29.1",
    path: `${routes.edit_announcement}/:code`,
    name: "edit_announcement",
    element: <EditAnnouncement />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "30",
    path: `${routes.contract_template}`,
    name: "contract_template",
    element: <ContractTemplate />,
    route: Route,
    moduleCode: "Master",
    accessCode: "ContarctType",
  },
  {
    id: "30.1",
    path: `${routes.add_contract_template}`,
    name: "add_contract_template",
    element: <CreateContractTemplate />,
    route: Route,
    moduleCode: "Master",
    accessCode: "ContarctType",
  },
  {
    id: "30.2",
    path: `${routes.edit_contract_template}/:code`,
    name: "edit_contract_template",
    element: <UpdateContractTemplate />,
    route: Route,
    moduleCode: "Master",
    accessCode: "ContarctType",
  },

  {
    id: "29.1",
    path: `${routes.ir8a_formlist}`,
    name: "ir8a_formlist",
    element: <IR8AFormList />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "29.2",
    path: `${routes.ir8a_generateForm}`,
    name: "ir8a_generateForm",
    element: <IR8AForm />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "29.3",
    path: `${routes.ir8a_edit_form}/:code`,
    name: "ir8a_edit_form",
    element: <EditIR8AForm />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "29",
    path: `${routes.notification_list}`,
    name: "notification_list",
    element: <AllNotification />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
];

export const reportRoutes = [
  {
    id: 25,
    path: `${routes.report_list}`,
    name: "report_list",
    element: <ReportList />,
    route: Route,
    moduleCode: "Report",
    accessCode: "",
  },
  {
    id: 25.1,
    path: `${routes.addition_deduction_report}`,
    name: "addition_deduction_report",
    element: <AdditionDeductionReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 25.1,
    path: `${routes.advance_payment_report}`,
    name: "advance_payment_report",
    element: <AdvancePaymentReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 25.1,
    path: `${routes.advance_repayment_report}`,
    name: "advance_repayment_report",
    element: <AdvanceRePaymentReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 25.1,
    path: `${routes.report}${routes.attendance_report}`,
    name: "Attendance Report",
    element: <AttendanceReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 26,
    path: `${routes.report}${routes.leave_report}`,
    name: "Leave Report",
    element: <LeaveReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 26.1,
    path: `${routes.report}${routes.emp_leave_history}`,
    name: "emp_leave_history",
    element: <EmpLeaveHistory />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 26.1,
    path: `${routes.report}${routes.employee_count_report}`,
    name: "employee_count_report",
    element: <EmployeeCountReport />,
    route: Route,
    moduleCode: "Report",
    accessCode: "Employee Details Report",
  },
  {
    id: 27,
    path: `${routes.report}${routes.payroll_report}`,
    name: "Payroll Report",
    element: <MonthlyPayrollSummary />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 28,
    path: `${routes.report}${routes.payslip_report}`,
    name: "Payslip Report",
    element: <PayslipReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.1",
    path: `${routes.contract_report}`,
    name: "contract_report",
    element: <EmpContractReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.expiry_report}`,
    name: "expiry_report",
    element: <ExpiryDocReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.forecast_report}`,
    name: "forecast_report",
    element: <ForecastReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.project_report}`,
    name: "project_report",
    element: <ProjectReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.man_hour_project_report}`,
    name: "man_hour_project_report",
    element: <ManHourProjectReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.project_costing_report}`,
    name: "project_costing_report",
    element: <ProjectCostingReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.daily_work_order_report}`,
    name: "daily_work_order_report",
    element: <DailyWorkOrderReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.emp_details_report}`,
    name: "emp_details_report",
    element: <EmployeeDetails />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.emp_levy_report}`,
    name: "emp_levy_report",
    element: <EmpLevyReport />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: "28.2",
    path: `${routes.report}${routes.emp_leave_history_report}`,
    name: "emp_leave_history_report",
    element: <EmpLeaveHistory />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },

  // Notification
];
export const authRoutes = [
  {
    id: 1,
    path: routes.login,
    name: "login",
    element: <Login />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 2,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <ForgotPassword />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 3,
    path: routes.recovery_mail,
    name: "recovery_mail",
    element: <PasswordSentSuccess />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  {
    id: 4,
    path: routes.reset_password,
    name: "reset_password",
    element: <ForgotPassword />,
    route: Route,
    moduleCode: "Dashboard",
    accessCode: "Dashboard",
  },
  // {
  //   id: 7,
  //   path: routes.forgotPasswordTwo,
  //   name: "forgotPasswordTwo",
  //   element: <ForgotpasswordTwo />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 8,
  //   path: routes.forgotPasswordThree,
  //   name: "forgotPasswordThree",
  //   element: <ForgotpasswordThree />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 9,
  //   path: routes.resetpassword,
  //   name: "resetpassword",
  //   element: <Resetpassword />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 10,
  //   path: routes.resetpasswordTwo,
  //   name: "resetpasswordTwo",
  //   element: <ResetpasswordTwo />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 11,
  //   path: routes.resetpasswordThree,
  //   name: "resetpasswordThree",
  //   element: <ResetpasswordThree />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 12,
  //   path: routes.emailverification,
  //   name: "emailverification",
  //   element: <EmailVerification />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 12,
  //   path: routes.emailverificationTwo,
  //   name: "emailverificationTwo",
  //   element: <EmailverificationTwo />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 13,
  //   path: routes.emailverificationThree,
  //   name: "emailverificationThree",
  //   element: <EmailverificationThree />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 14,
  //   path: routes.twostepverification,
  //   name: "twostepverification",
  //   element: <Twostepverification />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 15,
  //   path: routes.twostepverificationTwo,
  //   name: "twostepverificationTwo",
  //   element: <TwostepverificationTwo />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 16,
  //   path: routes.twostepverificationThree,
  //   name: "twostepverificationThree",
  //   element: <TwostepverificationThree />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 17,
  //   path: routes.lockscreen,
  //   name: "lockscreen",
  //   element: <Lockscreen />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 18,
  //   path: routes.error404,
  //   name: "error404",
  //   element: <Error404 />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 19,
  //   path: routes.error500,
  //   name: "error500",
  //   element: <Error500 />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 20,
  //   path: routes.comingsoon,
  //   name: "comingsoon",
  //   element: <Comingsoon />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
  // {
  //   id: 21,
  //   path: routes.undermaintenance,
  //   name: "undermaintenance",
  //   element: <Undermaintainence />,
  //   route: Route, moduleCode: "Dashboard", accessCode: "Dashboard",
  // },
];
